import { inject } from '@angular/core';
import { map, Observable } from 'rxjs';
import { GetSessionResponse, SessionsService } from '@session/infra';
import { toSessionViewModel } from '../../../mappers';
import { SessionDetailQueryResult } from './session-detail.query-result';

export class SessionDetailQueryHandler {
  private readonly sessionsService: SessionsService = inject(SessionsService);

  query(sessionId: string): Observable<SessionDetailQueryResult> {
    return this.sessionsService
      .getOne(sessionId)
      .pipe(map((dto: GetSessionResponse) => ({ session: toSessionViewModel(dto) })));
  }
}
